module.exports = __webpack_public_path__ + "static/media/icon_checkbox_default.38260b91.svg";